var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.post.front_container==='premium')?_c('div',{staticClass:"badge"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }